/*
 * Created by alex@hackerbay.com on 20.12.2018
 * Copyright Singularity Technologies GmbH (c) 2018. All rights reserved
 */

import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import {Col, Row} from "reactstrap";
import iconCopyLink from "../media/icons/copy.png"
import i18n from "i18next";

class SavePageButton extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            buttonCssClass: "button-gray-light"
        }

    }


    render() {


        return <div
            onClick={() => {
                this.locationInput.select();
                // console.log("copy");
                document.execCommand("copy");
                this.setState({buttonCssClass:"button-gray-light-clicked"});
            }
        }>
            <input
                ref={(locationInput) => this.locationInput = locationInput}
                value={window.location}
                id={"current-url-input"}
                readOnly={true}
                className={"copy-input-hidden"}
            />

            <Row className={"round-corners " + this.state.buttonCssClass} style={{marginRight:"0px"}}>
                <Col xs={4} style={{width:"100%", height:"66px"}}>
                    <img src={iconCopyLink} style={{height:"48px",width:"48px",marginTop:"8px",marginLeft:"-8px"}} alt={"copy link icon"} />
                </Col>
                <Col style={{marginTop:"8px"}}>
                    {i18n.t("copy_link")}
                </Col>
            </Row>
        </div>
    }
}

export default translate("translations")(SavePageButton);